import DispatcherComp from '@/components/DispatcherComp.vue';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/go-v2/:param',
    name: 'Go-V2',
    component: DispatcherComp,
    props: { source: 'GO' },
  },
  {
    path: '/tc-v2/:param',
    name: 'TC-V2',
    component: DispatcherComp,
    props: { source: 'TC', carrerpageorigin: 'TC' },
    beforeEnter: (to, from, next) => {
      if (to.query.carrerpageorigin !== 'TC') {
        const updatedQuery = { ...to.query, carrerpageorigin: 'TC' };
        next({ name: 'TC-V2', params: to.params, query: updatedQuery });
      } else {
        next();
      }
    },
  },
  {
    path: '/vb-v2/:param',
    name: 'Viber-V2',
    component: DispatcherComp,
    props: { isViber: true },
    meta: { apiCall: true, extCall: true },
  },
  {
    path: '/v2/:param([A-Za-z0-9]{5})',
    name: 'AlphaNumeric-V2',
    component: DispatcherComp,
    props: { source: 'PY' },
  },
  {
    path: '/go/:param',
    name: 'Go',
    component: DispatcherComp,
    props: { source: 'GO' },
    meta: { apiCall: true, extCall: true },
  },
  {
    path: '/tc/:param',
    name: 'TC',
    component: DispatcherComp,
    props: { source: 'TC', carrerpageorigin: 'TC' },
    beforeEnter: (to, from, next) => {
      if (to.query.carrerpageorigin !== 'TC') {
        const updatedQuery = { ...to.query, carrerpageorigin: 'TC' };
        next({ name: 'TC', params: to.params, query: updatedQuery });
      } else {
        next();
      }
    },
    meta: { apiCall: true, extCall: true },
  },
  {
    path: '/vb/:param',
    name: 'Viber',
    component: DispatcherComp,
    props: { isViber: true },
    meta: { apiCall: true, extCall: true },
  },
  {
    path: '/:param([A-Za-z0-9]{5})',
    name: 'AlphaNumeric',
    component: DispatcherComp,
    props: { source: 'PY' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
